import React from "react"
import PropTypes from "prop-types"
import urljoin from "url-join"
import { Link, graphql, useStaticQuery } from "gatsby"

import PreviewCompatibleImage from "../PreviewCompatibleImage"

const ChooseState = ({ service }) => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark(
        frontmatter: { sectionKey: { eq: "sections/choose-state" } }
      ) {
        frontmatter {
          sydney {
            title
            linkText
            imageAlt
            image {
              childImageSharp {
                fluid(quality: 100, maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          perth {
            title
            linkText
            imageAlt
            image {
              childImageSharp {
                fluid(quality: 100, maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  `)

  const { frontmatter } = data.markdownRemark

  const getRightImageSrc = src => {
    if (typeof src === "string") {
      return src
    }

    return {
      childImageSharp: {
        fluid: {
          ...src.childImageSharp.fluid,
          aspectRatio: 16 / 11,
        },
      },
    }
  }

  const statesPath = {
    sydney: {
      letters: `letters-of-administration-sydney-nsw`,
      probate: `probate-in-sydney-nsw`,
    },
    perth: {
      letters: `letters-of-administration-perth-wa`,
      probate: `probate-in-perth-wa`,
    },
  }

  return (
    <>
      <h2 className="font-bold d-block text-center mb-3">
        We Operate In
        <span className="d-inline-block bg-accent text-white px-3 py-2 m-2">
          Sydney
        </span>
        And
        <span className="d-inline-block bg-accent text-white px-3 py-2 m-2">
          Perth
        </span>
      </h2>
      <div className="row justify-content-center pt-5">
        {/* Sydney Card */}
        <div className="col-12 col-md-6 col-lg-5 col-xl-3 px-4 px-sm-6 px-md-2 mb-4 mb-md-0">
          <div className="overflow-hidden bg-white shadow d-flex flex-column custom-rounded-lg">
            <div className="header font-size-lg-5 px-5 py-4 text-white text-center font-bold bg-accent">
              {frontmatter.sydney.title}
            </div>
            <PreviewCompatibleImage
              src={getRightImageSrc(frontmatter.sydney.image)}
              alt={frontmatter.sydney.imageAlt}
            />
            <div className="p-4">
              <Link
                to={urljoin("/lost-a-loved-one/", statesPath.sydney[service])}
                className="btn btn-primary btn-lg btn-block font-size-lg"
              >
                {frontmatter.sydney.linkText}
              </Link>
            </div>
          </div>
        </div>

        {/* Perth Card */}
        <div className="col-12 col-md-6 col-lg-5 col-xl-3 px-4 px-sm-6 px-md-2 mb-md-0">
          <div className="overflow-hidden bg-white shadow d-flex flex-column custom-rounded-lg">
            <div className="header font-size-lg-5 bg-accent px-5 py-4 text-white text-center font-bold">
              {frontmatter.perth.title}
            </div>
            <PreviewCompatibleImage
              src={getRightImageSrc(frontmatter.perth.image)}
              alt={frontmatter.perth.imageAlt}
            />
            <div className="p-4">
              <Link
                to={urljoin("/lost-a-loved-one/", statesPath.perth[service])}
                className="btn btn-primary btn-lg btn-block font-size-lg"
              >
                {frontmatter.perth.linkText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

ChooseState.propTypes = {
  service: PropTypes.oneOf(["letters", "probate"]).isRequired,
}

export default ChooseState
